export default __webpack_public_path__ + "static/media/r3.d65adf00.jpg";